import React, { Component } from 'react'
import { connect } from 'react-redux'
import {routerShape} from 'react-router'
import URL from 'url'
import _ from 'lodash'
import MessageList from './MessageList'
import { addErrorMessage } from '../action-creators/add-message'
import establishSession from '../helpers/establishSession'
import createSmeRedirectUrl from '../helpers/createSmeRedirectUrl'
import LoadingContent from '@myob/myob-widgets/lib/components/spinner/LoadingContent'
import codifyUrlStateParams from '../helpers/codifyURLStateParams';
import saveUriState from '../action-creators/save-uri-state'
import configHandler from '../configHandler';

const redirectTo = urlPath => window.location = urlPath;
const createLoginFormRedirectUrl = state => `/#/login?state=${state}`;

const createStateWithCompanyFilename = (response, state) => {
  return response.json().then(data => {
    const companyFilename = _.get(data, 'errors[0].meta.companyFilename', '');
    const stateWithCompanyFilename = {...state, companyFilename};
    return createLoginFormRedirectUrl(encodeURIComponent(btoa(JSON.stringify(stateWithCompanyFilename))));
  });
};

class Home extends Component {

  constructor(props) {
    super(props);
    this.state = { isLoading: true }
  }

  componentWillMount() {
    const config = configHandler();

    const publicApiUri = config.TAXONLINE_PUBLIC_API_URL,
      url = URL.parse(window.location.href, true),
      code = url.query.code,
      encodedState = url.query.state,
      state = codifyUrlStateParams.decode(encodedState);

    this.props.saveUriStateToStore(state);

    if (code && encodedState) {
      establishSession(code, encodedState, publicApiUri)
        .then(res => {
          if (res.status === 200) {
            return res.json().then(body => {
              return createSmeRedirectUrl(encodedState, body.uid);
            });
          }
          if (res.status === 403) {
            return createStateWithCompanyFilename(res, state);
          }
        })
        .then(redirectTo)
        .catch(err => {
          this.setState({ isLoading: false });
          this.props.addErrorMessage(err.message);
        })
    } else {
      this.context.router.push('/notfound');
    }
  }

  render() {
    return (
      <div>
        <MessageList />
        <br />
        <LoadingContent size='medium' isLoading={this.state.isLoading}/>
      </div>
    )
  }
}

Home.contextTypes = {
  router: routerShape.isRequired
};

Home.propTypes = {
  saveUriStateToStore: React.PropTypes.func.isRequired,
  addErrorMessage: React.PropTypes.func.isRequired
};

export default connect(
  () => ({}),
  dispatch => ({
    saveUriStateToStore: state => dispatch(saveUriState(state)),
    addErrorMessage: message => dispatch(addErrorMessage(message))
  })
)(Home);



// WEBPACK FOOTER //
// ./src/app/components/Home.js